import type { FaireProductEntity } from "../../entity_types/product";

export const p_ew7verqem4: FaireProductEntity = {
  token: "p_ew7verqem4",
  type: "product",
  name: "Short Stack Pancake Sticky Notes",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/3a155d77bf98636d5c5bd5f858a183e2ec77d1f2ea819534b7cf5778ac47fc69.png",
  galleryImageUrls: [],
  priceDollars: 4,
  description: "Short Stack Notes are inspired by slow mornings, roadside diners and lists made over coffee. This food-illustrated sticky note brings the diner to your desk, planner, or notebook—perfect for reminders, to-dos, and love notes slipped onto loose papers.\n\nA must-have for stationery lovers, foodies, and design-forward desks, Short Stack Pancake Notes make everyday organization feel a little more indulgent.\n\nGood to know: \n\n * 50 adhestive sheets \n * Stick & restick anywhere. \n * Measures 3in x 3in \n * 100% Recyclable ",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:34:03.308Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
